<template>
  <div id="emh-srp" :dir="direction" class="emh-shop__container">
    <emh-router-view />
  </div>
</template>
<script lang="ts">
import EmhRouterView from '@dh-io-emh/shared/src/components/utils/emhRouterView/index.vue';
import { useDirection } from '@dh-io-emh/shared/src/composables/direction.composable';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AemSrp',
  components: {
    EmhRouterView,
  },
  setup() {
    const direction = useDirection();

    return { direction };
  },
});
</script>
<style lang="scss">
@import 'https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/6.12.0/css/globals.css';

.emh-shop {
  &__container {
    margin: 0 auto;
    color: var(--wb-grey-20);
    background-color: var(--wb-grey-90); // (2)

    // Need to override PLS modal z-index for it to not be over OWC subnavigation
    .dh-price-display-price-breakdown__popover-content {
      z-index: 700;
    }
  }
}
</style>
